module.exports = __webpack_public_path__ + "img/under_construction.0a753aeb.jpg";